import Vue from 'vue'
import Router from 'vue-router'

import home from '@/modules/home/router.js'
import staffarea from '@/modules/staffarea/router.js'
import booking from '@/modules/booking/router.js'
import auth from '@/modules/auth/router.js'
import profile from '@/modules/profile/router.js'
import corporate from '@/modules/corporate/router.js'
import login from '@/modules/auth/login/index.vue'
import navigation from '@/modules/navigation/router.js'
import store from '@/store'

Vue.use(Router)

const router = new Router({
  routes: [
    ...home,
    ...profile,
    ...auth,
    ...booking,
    ...corporate,
    ...staffarea,
    ...navigation,
    { path: '*', component: login }
  ]
  // mode: 'history'
})

router.beforeEach((to, from, next) => {
  /**
   * This block is for checking to see if we can / need to pull booking information from local storage.
   * It resolves once any remember-me re-auth attempt it kicked off has settled, so the requiresAuth
   * check below doesn't race the (necessarily async, since it awaits the booking load) auth commit.
   */
  checkLocalStore(to).then(() => {
    /**
     * Now see if we have set a property on the route to either require a bookno & name or username & password for senstitive areas
     * Vue Router has a matched property which returns all routes that match the current URL pattern (because theere might be more thean one)
     *  look here - https://router.vuejs.org/guide/advanced/meta.html
     *  requiresAuth = Need bookno + bookname
     *  requiresToken = Need Username + Password
     */

    if (to.matched.some((route) => route.meta.requiresAuth)) {
      // we need bookno + bookname = check the auth store to see if this is set
      if (store.getters['auth/isAuthenticated'] === false) {
        // No Userdata in the store - redirect to login route
        return next({ path: '/login' })
      }
    }

    // Now check for Token Auth
    if (to.matched.some((route) => route.meta.requiresTokenAuth)) {
      if (store.getters['auth/isAuthorisedWithToken'] === false) {
        return next({
          path: '/',
        })
      }
    }

    // Check if booking is being viewed internally and update store value if so
    if (from.params && from.params.source === 'int') {
      store.dispatch('updateInternal', true)
    } else if (
      to.params &&
      to.params.source === 'int' &&
      from.name === null &&
      from.matched.length === 0
    ) {
      store.dispatch('updateInternal', true)
    }

    // Else go next
    next()
  })
})

export default router

function checkLocalStore(to) {
  // These routes are either passed booking information as part of the URL or we want to reset e.g. login
  const ignoreRoutes = [
    'bookingauth',
    'bookingauthsource',
    'landingauth',
    'landingauthsource',
    'triphubauth',
    'triphubauthsource',
    'login',
    'loginCorporate',
    'profileCorp',
    'friendandfamily',
    'weddingabroad',
    'travelHealthAuth',
    'flightsAuth',
    'baggageAuth',
    'vouchersAuth',
    'commsauthsource',
  ]

  // The following guard checks to see if it is not one of these routes
  if (ignoreRoutes.indexOf(to.name) === -1) {
    // anything in the store saved?
    if (!store.state.auth || !store.state.auth.userData) {
      // Nothing saved in the store so try and load it - wait for it to settle (success or
      // failure) before the beforeEach guard decides whether to redirect to /login, otherwise
      // a remembered login always loses the race against its own re-auth attempt
      const options =
        to.path === '/landing-corp' || to.path === '/profile-corp'
          ? { noBookingInit: true }
          : {}
      return store
        .dispatch('auth/initAuth', options, { root: true })
        .catch(() => {})
    }
  }
  return Promise.resolve()
}
